import React, { useReducer } from 'react'
import { NavLink } from 'react-router'
import { Container, Row, Col, Card, ButtonGroup, ToggleButton, Button } from 'react-bootstrap'

export function Ikavali({state, dispatch}) {

const ikavali = state === null ? null : state.ikavali

const setRange = (e) => {
	dispatch({type:'ikavali', payload: e})
}

return (
 	<Col xs={12}>
	<Card style={{'margin':'1rem'}}>
	<Card.Header>Ikäväli</Card.Header>
	<Card.Body   style={{'textAlign': 'center'}}>
	<ButtonGroup className='mb-2 d-none d-sm-block'>
		<ToggleButton key={1} id='age-1' variant='outline-secondary' type='checkbox' name='age-1' value={'4-6'} checked={ikavali==='4-6'} onChange={(e) => setRange(e.target.value)} >4-6 vuotta</ToggleButton>
		<ToggleButton key={2} id='age-2' variant='outline-secondary' type='checkbox' name='age-2' value={'7-12'} checked={ikavali==='7-12'} onChange={(e) => setRange(e.target.value)} >7-12 vuotta</ToggleButton>
		<ToggleButton key={3} id='age-3' variant='outline-secondary' type='checkbox' name='age-3' value={'13-17'} checked={ikavali==='13-17'} onChange={(e) => setRange(e.target.value)} >13-17 vuotta</ToggleButton>
	</ButtonGroup>
	<ButtonGroup className='mb-2 d-block d-sm-none' vertical>
		<ToggleButton key={1} id='age-1' variant='outline-secondary' type='checkbox' name='age-1' value={'4-6'} checked={ikavali==='4-6'} onChange={(e) => setRange(e.target.value)} >4-6 vuotta</ToggleButton>
		<ToggleButton key={2} id='age-2' variant='outline-secondary' type='checkbox' name='age-2' value={'7-12'} checked={ikavali==='7-12'} onChange={(e) => setRange(e.target.value)} >7-12 vuotta</ToggleButton>
		<ToggleButton key={3} id='age-3' variant='outline-secondary' type='checkbox' name='age-3' value={'13-17'} checked={ikavali==='13-17'} onChange={(e) => setRange(e.target.value)} >13-17 vuotta</ToggleButton>
	</ButtonGroup>
	</Card.Body>
	</Card>
	</Col>
)
}

export const vireystila_list = [ 'ylivireys', 'alivireys', 'masennus']


export function Vireystila({state, dispatch}) {
const vireystila = state === null ? null : state.vireystila

const setState = (e) => {
	dispatch({type: 'vireystila', payload: e})
}

return (
 	<Col xs={12}>
	<Card style={{'margin':'1rem'}}>
	<Card.Header>Vireystila</Card.Header>
	<Card.Body   style={{'textAlign': 'center'}}>
	<ButtonGroup className='mb-2 d-none d-sm-block'>
		<ToggleButton key={1} id='state-1' variant='outline-secondary' type='checkbox' name='vireys-1' value={'ylivireys'} checked={vireystila==='ylivireys'} onChange={(e) => setState(e.target.value)} >Ylivireys</ToggleButton>
		<ToggleButton key={2} id='state-2' variant='outline-secondary' type='checkbox' name='vireys-2' value={'alivireys'} checked={vireystila==='alivireys'} onChange={(e) => setState(e.target.value)} >Alivireys</ToggleButton>
		<ToggleButton key={3} id='state-3' variant='outline-secondary' type='checkbox' name='vireys-3' value={'masennus'} checked={vireystila==='masennus'} onChange={(e) => setState(e.target.value)} >Masennus</ToggleButton>
	</ButtonGroup>
	<ButtonGroup className='mb-2 d-block d-sm-none' vertical>
		<ToggleButton key={1} id='state-1' variant='outline-secondary' type='checkbox' name='vireys-1' value={'ylivireys'} checked={vireystila==='ylivireys'} onChange={(e) => setState(e.target.value)} >Ylivireys</ToggleButton>
		<ToggleButton key={2} id='state-2' variant='outline-secondary' type='checkbox' name='vireys-2' value={'alivireys'} checked={vireystila==='alivireys'} onChange={(e) => setState(e.target.value)} >Alivireys</ToggleButton>
		<ToggleButton key={3} id='state-3' variant='outline-secondary' type='checkbox' name='vireys-3' value={'masennus'} checked={vireystila==='masennus'} onChange={(e) => setState(e.target.value)} >Masennus</ToggleButton>
	</ButtonGroup>
	</Card.Body>
	</Card>
	</Col>
)
}

export const turvallisuus_list = [ 'turvallinen', 'neutraali','turvaton' ]


export function Turvallisuus({state, dispatch}) {
const turvallisuus = state === null ? null : state.turvallisuus

const setState = (e) => {
	dispatch({type: 'turvallisuus', payload: e})
}

return (
 	<Col xs={12}>
	<Card style={{'margin':'1rem'}}>
	<Card.Header>Turvallisuus</Card.Header>
	<Card.Body   style={{'textAlign': 'center'}}>
	<ButtonGroup className='mb-2 d-none d-sm-block'>
		<ToggleButton key={1} id='turvallisuus-1' variant='outline-secondary' type='checkbox' name='turvallisuus-1' value={'turvallinen'} checked={turvallisuus==='turvallinen'} onChange={(e) => setState(e.target.value)} >Turvallinen</ToggleButton>
		<ToggleButton key={2} id='turvallisuus-2' variant='outline-secondary' type='checkbox' name='turvallisuus-2' value={'neutraali'} checked={turvallisuus==='neutraali'} onChange={(e) => setState(e.target.value)} >Neutraali</ToggleButton>
		<ToggleButton key={3} id='turvallisuus-3' variant='outline-secondary' type='checkbox' name='turvallisuus-3' value={'turvaton'} checked={turvallisuus==='turvaton'} onChange={(e) => setState(e.target.value)} >Turvaton</ToggleButton>
	</ButtonGroup>
	<ButtonGroup className='mb-2 d-block d-sm-none' vertical>
		<ToggleButton key={1} id='turvallisuus-1' variant='outline-secondary' type='checkbox' name='turvallisuus-1' value={'turvallinen'} checked={turvallisuus==='turvallinen'} onChange={(e) => setState(e.target.value)} >Turvallinen</ToggleButton>
		<ToggleButton key={2} id='turvallisuus-2' variant='outline-secondary' type='checkbox' name='turvallisuus-2' value={'neutraali'} checked={turvallisuus==='neutraali'} onChange={(e) => setState(e.target.value)} >Neutraali</ToggleButton>
		<ToggleButton key={3} id='turvallisuus-3' variant='outline-secondary' type='checkbox' name='turvallisuus-3' value={'turvaton'} checked={turvallisuus==='turvaton'} onChange={(e) => setState(e.target.value)} >Turvaton</ToggleButton>
	</ButtonGroup>
	</Card.Body>
	</Card>
	</Col>
)
}


export function Erityistarve({state, dispatch}) {

const neuropsykiatrinen = state === null ? false : state.erityistarve.neuropsykiatrinen
const tunteiden_hallinta = state === null ? false : state.erityistarve.tunteiden_hallinta
const kaytoksen_hallinta = state === null ? false : state.erityistarve.kaytoksen_hallinta
const syomisen_ongelmat = state === null ? false : state.erityistarve.syomisen_ongelmat

const setState = (t, e) => {
	dispatch({type: t, payload: e})
}

return (
 	<Col xs={12}>
	<Card style={{'margin':'1rem'}}>
	<Card.Header>Erityistarve</Card.Header>
	<Card.Body   style={{'textAlign': 'center'}}>
	<ButtonGroup className='mb-2 d-none d-md-block'>
		<ToggleButton key={1} id='neuropsykiatrinen' variant='outline-secondary' type='checkbox' name='neuropsykiatrinen' value={!neuropsykiatrinen} checked={neuropsykiatrinen} onChange={(e) => setState('neuropsykiatrinen',e.target.value)} >Neuropsykiatrinen</ToggleButton>
		<ToggleButton key={2} id='tunteiden_hallinta' variant='outline-secondary' type='checkbox' name='tunteiden_hallinta' value={!tunteiden_hallinta} checked={tunteiden_hallinta} onChange={(e) => setState('tunteiden_hallinta', e.target.value)} >Tunteiden hallinta</ToggleButton>
		<ToggleButton key={3} id='kaytoksen_hallinta' variant='outline-secondary' type='checkbox' name='kaytoksen_hallinta' value={!kaytoksen_hallinta} checked={kaytoksen_hallinta} onChange={(e) => setState('kaytoksen_hallinta', e.target.value)} >Käytöksenhallinta</ToggleButton>
		<ToggleButton key={4} id='syomisen_ongelmat' variant='outline-secondary' type='checkbox' name='syomisen_ongelmat' value={!syomisen_ongelmat} checked={syomisen_ongelmat} onChange={(e) => setState('syomisen_ongelmat', e.target.value)} >Syömisen ongelmat</ToggleButton>
	</ButtonGroup>
	<ButtonGroup className='mb-2 d-block d-md-none' vertical>
		<ToggleButton key={1} id='neuropsykiatrinen' variant='outline-secondary' type='checkbox' name='neuropsykiatrinen' value={!neuropsykiatrinen} checked={neuropsykiatrinen} onChange={(e) => setState('neuropsykiatrinen',e.target.value)} >Neuropsykiatrinen</ToggleButton>
		<ToggleButton key={2} id='tunteiden_hallinta' variant='outline-secondary' type='checkbox' name='tunteiden_hallinta' value={!tunteiden_hallinta} checked={tunteiden_hallinta} onChange={(e) => setState('tunteiden_hallinta', e.target.value)} >Tunteiden hallinta</ToggleButton>
		<ToggleButton key={3} id='kaytoksen_hallinta' variant='outline-secondary' type='checkbox' name='kaytoksen_hallinta' value={!kaytoksen_hallinta} checked={kaytoksen_hallinta} onChange={(e) => setState('kaytoksen_hallinta', e.target.value)} >Käytöksenhallinta</ToggleButton>
		<ToggleButton key={4} id='syomisen_ongelmat' variant='outline-secondary' type='checkbox' name='syomisen_ongelmat' value={!syomisen_ongelmat} checked={syomisen_ongelmat} onChange={(e) => setState('syomisen_ongelmat', e.target.value)} >Syömisen ongelmat</ToggleButton>
	</ButtonGroup>
	
	</Card.Body>
	</Card>
	</Col>
)
}

export function initState() {
	return {
		name: 'Potilas',
		ikavali: null,
		erityistarve: {
			neuropsykiatrinen: false,
			tunteiden_hallinta: false,
			kaytoksen_hallinta: false,
			syomisen_ongelmat: false
		},
		vireystila: null,
		turvallisuus: null,
		vireys_sana: null,
		vireys_sana_show : false,
		valid: false
	}
}


export function reducer(state, action) {
	console.log('reducer', state, action)
	const newState = { ...state }
	switch(action.type) {
		case 'ikavali':
			newState.ikavali = action.payload
			break
		case 'vireystila':
			newState.vireystila = action.payload
			break
		case 'turvallisuus':
			newState.turvallisuus = action.payload
			break
		case 'neuropsykiatrinen':
			newState.erityistarve.neuropsykiatrinen = action.payload === true || action.payload === 'true'
			break
		case 'tunteiden_hallinta':
			newState.erityistarve.tunteiden_hallinta = action.payload === true || action.payload === 'true'
			break
		case 'kaytoksen_hallinta':
			newState.erityistarve.kaytoksen_hallinta = action.payload === true || action.payload === 'true'
			break
		case 'syomisen_ongelmat':
			newState.erityistarve.syomisen_ongelmat = action.payload === true || action.payload === 'true'
			break
		default:
			return state
	}
	newState.valid = newState.ikavali && newState.vireystila && newState.turvallisuus && 
			(newState.erityistarve.neuropsykiatrinen || newState.erityistarve.tunteiden_hallinta || 
			newState.erityistarve.kaytoksen_hallinta || newState.erityistarve.syomisen_ongelmat) ? true : false
	return newState	
}

export function Seuraava() {
return (
	<Row> 
	<Col xs='auto'>
	<Card style={{'margin':'1rem'}}>
	<Card.Body   style={{'textAlign': 'left'}}>
	<NavLink to='/selection' end>
	<Button size="lg">Seuraava</Button>
	</NavLink>
	</Card.Body>
	</Card>
	</Col>
	</Row>
)
}



export function Vastaanotto() {
const [state, dispatch] = useReducer(reducer, {},  initState)
console.log('Vastaanotto', state)
return(
	<Container fluid style={{'maxWidth': '1100px'}}>
	<Row>
 	<Ikavali state={state} dispatch={dispatch} />
	<Erityistarve state={state} dispatch={dispatch} />
	<Vireystila state={state} dispatch={dispatch} />
	<Turvallisuus state={state} dispatch={dispatch} />
	</Row>
	{ state && state.valid && <Seuraava /> 	}
	</Container>
)
}